// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class CeleryTaskResource extends Resource {
    basePath: string = 'async_tasks/celery-tasks/';

    objectPath: string = 'async_tasks/celery-tasks/{ident}/';

    getRunningTasksForUser() {
        return this.client._request(
            // $FlowFixMe
            `${this._getBasePath()}get_running_tasks_for_user/`,
            'GET',
        ).then((response) => response.data);
    }
}
